import { Box, StackProps, SxProps, Typography } from '@mui/material';
import { IPackage } from 'entities/mine-package/model';

import { BackgroundCard, EarnCalculator, paymentSuccess } from '../../shared';

interface SuccessViewBaseProps {
  title: string;
  subtitle: string;
  sx?: SxProps;
  tap2minePackage?: IPackage | null;
}

export const SuccessViewBase = ({
  subtitle,
  title,
  children,
  sx,
  tap2minePackage,
  ...props
}: SuccessViewBaseProps & Omit<StackProps, 'sx'>) => {
  return (
    <BackgroundCard {...props} sx={sx}>
      <Box
        component="img"
        alt="success"
        src={paymentSuccess}
        sx={{ width: 121, height: 121, objectFit: 'contain' }}
        mb={{ xs: 1.5, md: 2 }}
      />
      <Typography variant="h4" fontSize={{ xs: '19px', md: '24px' }} className="primary" textAlign="center" mb={2}>
        {title}
      </Typography>
      <Typography variant="body2" className="primary" textAlign="center" mb={{ xs: 2, sm: 2.25 }}>
        {subtitle}
      </Typography>

      {children}

      {tap2minePackage && <EarnCalculator tap2minePackage={tap2minePackage} sx={{ mb: { xs: 1, sm: 2 } }} />}

      <Typography variant="body2" className="primary" textAlign="center">
        Tap-2-Mine launches soon! <br />
        Stay tuned on our social channels for <br />
        mining rig license updates.
      </Typography>
    </BackgroundCard>
  );
};
